import { Col, Input, Label, Row } from "reactstrap";
import { AsyncPaginatedSelect } from "components/common/AsyncPaginatedSelect";
import { getClientOptions } from "features/Clients/services/ClientService";
import {
  ComplaintMaterialStatus,
  ComplaintMaterialStatusLabel,
  ComplaintMaterialWarrantyStatus,
  ComplaintMaterialWarrantyStatusLabel,
} from "features/ComplaintMaterials/constants/complaint-material.constants";

export type ComplaintMaterialListFiltersProps = {
  status: ComplaintMaterialStatus | "";
  onStatusChange: (value: ComplaintMaterialStatus | "") => void;
  clientId: number | null;
  clientOption?: { value: number; label: string };
  onClientChange: (
    id: number | null,
    option?: { value: number; label: string },
  ) => void;
  warrantyStatus: ComplaintMaterialWarrantyStatus | "";
  onWarrantyStatusChange: (value: ComplaintMaterialWarrantyStatus | "") => void;
};

export default function ComplaintMaterialListFilters({
  status,
  onStatusChange,
  clientId,
  clientOption,
  onClientChange,
  warrantyStatus,
  onWarrantyStatusChange,
}: ComplaintMaterialListFiltersProps) {
  return (
    <Row className="g-2 g-md-3 align-items-end flex-grow-1 w-100 mb-0">
      <Col xs={12} sm={6} md={3}>
        <Label className="form-label text-muted small mb-1">Status</Label>
        <Input
          type="select"
          className="form-select"
          value={status}
          onChange={(e) =>
            onStatusChange((e.target.value || "") as ComplaintMaterialStatus | "")
          }
        >
          <option value="">All statuses</option>
          {(Object.values(ComplaintMaterialStatus) as ComplaintMaterialStatus[]).map(
            (s) => (
              <option key={s} value={s}>
                {ComplaintMaterialStatusLabel[s]}
              </option>
            ),
          )}
        </Input>
      </Col>

      <Col xs={12} sm={6} md={3}>
        <Label className="form-label text-muted small mb-1">Client</Label>
        <AsyncPaginatedSelect
          fetchOptions={getClientOptions}
          placeholder="All clients"
          defaultOption={clientOption}
          value={clientId}
          onChange={(opt: any) =>
            onClientChange(
              opt && !Array.isArray(opt) ? Number(opt.value) : null,
              opt && !Array.isArray(opt)
                ? { value: opt.value, label: opt.label }
                : undefined,
            )
          }
        />
      </Col>

      <Col xs={12} sm={6} md={3}>
        <Label className="form-label text-muted small mb-1">Warranty</Label>
        <Input
          type="select"
          className="form-select"
          value={warrantyStatus}
          onChange={(e) =>
            onWarrantyStatusChange(
              (e.target.value || "") as ComplaintMaterialWarrantyStatus | "",
            )
          }
        >
          <option value="">All</option>
          {(
            Object.values(
              ComplaintMaterialWarrantyStatus,
            ) as ComplaintMaterialWarrantyStatus[]
          ).map((w) => (
            <option key={w} value={w}>
              {ComplaintMaterialWarrantyStatusLabel[w]}
            </option>
          ))}
        </Input>
      </Col>
    </Row>
  );
}
